import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/sysDealerInfos/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/sysDealerInfos/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/sysDealerInfos/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/sysDealerInfos/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/sysDealerInfos/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/sysDealerInfos/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getByUser(id) {
  return request({
    url: '/sysDealerInfos/GetByUser',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/sysDealerInfos/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
